import "./welcome.css"
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Logout from "../../logout/Logout";
import { connect } from "react-redux";
import axios from "axios";
import Alert from "react-bootstrap/Alert";

function WelcomeToInfo({ appData }) {

    const { t } = useTranslation()
    const [showAlert, setShowAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successAlert, setSuccessAlert] = useState(false);
    const fileInputRef = useRef(null);
    const [selectedFiles, setSelectedFiles] = useState([]);

    useEffect(() => {
        window.gtag('config', 'AW-937928979');

        window.gtag('event', 'conversion', {
            'send_to': 'AW-937928979/5PP9CKnCk2QQk9KevwM',
        });
    }, []);

    useEffect(() => {
        function disableBack() {
            window.history.pushState(null, null, window.location.href);
            window.onpopstate = function () {
                window.history.pushState(null, null, window.location.href);
            };
        }

        disableBack();

        return () => {
            window.history.forward();
        };
    }, []);

    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                setShowAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [showAlert]);

    useEffect(() => {
        if (successAlert) {
            const timer = setTimeout(() => {
                setSuccessAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [successAlert]);

    const handleUpload = async () => {
        const selectedFiles = fileInputRef.current.files;

        if (!selectedFiles) {
            return;
        }

        for (const selectedFile of selectedFiles) {
            if (selectedFile.size > 6 * 1024 * 1024) {
                setShowAlert(true);

                setTimeout(() => {
                    setErrorMessage('');
                    setShowAlert(false);
                }, 3000);

                return;
            }

            const allowedTypes = ["pdf", "x-pdf", "jpeg", "gif", "png", "jpg"];
            const fileType = selectedFile.type.split("/")[1];
            if (!allowedTypes.includes(fileType)) {
                setErrorMessage("File type not allowed. Allowed types: pdf, jpeg, gif, png, jpg");
                setShowAlert(true);
                return;
            }

            const formData = new FormData();
            formData.append("file", selectedFile);

            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/accounts/upload/${appData.app_id}`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (response.data.status === '403') {
                    setShowAlert(true);
                } else {
                    setSelectedFiles(prevFiles => [...prevFiles, selectedFile.name]);
                    if (response.data.message) {
                        setErrorMessage(response.data.message);
                        setSuccessAlert(false);
                    } else {
                        setErrorMessage('');
                        setSuccessAlert(true);
                        trackConversion();
                    }
                }

                if (response.data && response.data.status && ['404', '500'].includes(response.data.status)) {
                    throw new Error(response.data.message || 'Unknown error occurred');
                }

            } catch (error) {
                console.error("Unhandled error:", error);
                throw error;
            }
        }

        fileInputRef.current.value = null;
    };

    const trackConversion = () => {
        var _promocode = ''; /* promocode, if any */
        function _enc(s) {
            if (typeof encodeURIComponent == 'function') {
                return encodeURIComponent(s);
            } else {
                return escape(s);
            }
        }
        var _referer = document.referrer;
        var i = new Image(1, 1);
        i.src = 'https://directtrack.choicetrade.com/redirect/img.php?promocode=' + _enc(_promocode) + '&referer=' + _enc(_referer) + '&type=sale';

        i.onload = function () {
            return;
        }
    };

    return (
        <div className="welcome_to">
            <Logout />
            <p className="welcome_to_heading">{t('welcome_to.welcome_to')}</p>
            <div className="welcome_to_content">
                <p className="app_complete_text">{t('welcome_to.complete_app')} {appData.app_id} {t('welcome_to.complete_app_continue')}</p>
                <div>
                    <p className="account_funding">{t('welcome_to.account_funding')}</p>
                    <p className="account_funding_text">{t('welcome_to.funding_instruction')} <a
                        style={{ textDecoration: "none", color: "white" }} href="https://www.choicetrade.com/fund.php"
                        target="_blank" rel="noreferrer">{t('welcome_to.click_here')}</a></p>
                </div>
                <p className="attention_text">{t('welcome_to.attention')}</p>
                <p className="us_app">{t('welcome_to.application')}</p>
                <p className="non_resident">{t('welcome_to.non_resident')}</p>
            </div>
            <label className="upload_btn">
                <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUpload}
                    ref={fileInputRef}
                    multiple
                />
                <span>{t("welcome_to.upload")}</span>
            </label>
            <div className="selected-files">
                {selectedFiles.length > 0 && (
                    <>
                        <ul style={{ width: "18%" }}>
                            {selectedFiles.map((file, index) => (
                                <li key={index} className="file_list">{file}</li>
                            ))}
                        </ul>
                    </>
                )}
            </div>
            <div className="alert_message" style={{ width: '30%' }}>
                {showAlert && (
                    <Alert variant="danger">
                        Only allowed pdf, x-pdf, jpeg, gif, png, jpg files with a size under 6MB.
                    </Alert>
                )}

                {errorMessage && (
                    <Alert variant="danger">
                        {errorMessage}
                    </Alert>
                )}

                {successAlert && !errorMessage && !showAlert && (
                    <Alert variant="success">
                        File uploaded successfully
                    </Alert>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    appData: state.appData
});

export default connect(mapStateToProps)(WelcomeToInfo);